import React, { useMemo, useState } from "react";
import { Search, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function SearchBar({ countries, onSelect }) {
  const { lang, t } = useLang();
  const [q, setQ] = useState("");

  const results = useMemo(() => {
    if (!q.trim()) return [];
    const needle = q.trim().toLowerCase();
    return countries
      .filter((c) => {
        return (
          c.names.ar.toLowerCase().includes(needle) ||
          c.names.en.toLowerCase().includes(needle) ||
          c.short_names.ar.toLowerCase().includes(needle) ||
          c.short_names.en.toLowerCase().includes(needle) ||
          c.code.toLowerCase() === needle
        );
      })
      .slice(0, 8);
  }, [q, countries]);

  return (
    <div className="relative w-full" data-testid="search-bar">
      <div className="relative">
        <Search className="absolute top-1/2 -translate-y-1/2 start-3 w-4 h-4 text-muted-foreground pointer-events-none" />
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t("search_placeholder")}
          className="w-full h-11 rounded-full border border-stoneLine bg-card ps-10 pe-10 text-sm outline-none focus:border-ochre focus:ring-2 focus:ring-ochre/20 transition-colors"
          data-testid="search-input"
        />
        {q && (
          <button
            onClick={() => setQ("")}
            className="absolute top-1/2 -translate-y-1/2 end-3 w-6 h-6 rounded-full hover:bg-sandDeep/60 flex items-center justify-center"
            data-testid="search-clear"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      {q && (
        <div className="absolute z-30 mt-2 w-full rounded-2xl border border-stoneLine bg-card shadow-lg overflow-hidden" data-testid="search-results">
          {results.length === 0 ? (
            <div className="px-4 py-3 text-sm text-muted-foreground">{t("no_results")}</div>
          ) : (
            <ul className="max-h-80 overflow-y-auto thin-scroll">
              {results.map((c) => (
                <li key={c.code}>
                  <button
                    onClick={() => { onSelect(c.code); setQ(""); }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-sandDeep/50 text-start transition-colors"
                    data-testid={`search-result-${c.code}`}
                  >
                    <img src={c.flag_url} alt="" className="w-7 h-5 object-cover rounded-sm border border-stoneLine" />
                    <div className="min-w-0">
                      <div className="text-sm font-medium text-ink truncate">{c.short_names[lang]}</div>
                      <div className="text-xs text-muted-foreground truncate">{c.capital[lang]}</div>
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
